import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import LinkButton from "components/buttons/link_button";
import styles from "../policy_checkbox.module.css";
import PolicyLink from "components/policy_link";
import PrivacyPolicyInfoModal from "./privacy_policy_info_modal/policy_info_modal";

import PolicyInfoModal from "./policy_info_modal";

export default function PolicyInfo({ selectedRatesByRoom }) {
  const { t } = useTranslation();
  const [isBookingModalShown, setIsBookingModalShown] = useState(false);
  const [isPivacyModalShown, setIsPrivacyModalShown] = useState(false);

  const bookingToggleModal = useCallback(() => {
    setIsBookingModalShown(!isBookingModalShown);
  }, [isBookingModalShown]);

  const privacyToggleModal = useCallback(() => {
    setIsPrivacyModalShown(!isPivacyModalShown);
  }, [isPivacyModalShown]);

  return (
    <>
      {selectedRatesByRoom && (
        <>
          <LinkButton className={styles.link} onClick={bookingToggleModal}>
            {t("payment_page:booking_policy")}{" "}
          </LinkButton>

          <span>and</span>
        </>
      )}
      <LinkButton className={styles.link} onClick={privacyToggleModal}>
        {t("payment_page:privacy_policy")}{" "}
      </LinkButton>

      <PolicyLink />
      {selectedRatesByRoom && (
        <PolicyInfoModal
          show={isBookingModalShown}
          onHide={bookingToggleModal}
          selectedRatesByRoom={selectedRatesByRoom}
        />
      )}
      <PrivacyPolicyInfoModal show={isPivacyModalShown} onHide={privacyToggleModal} />
    </>
  );
}
